const AvatarInput = () => {
  const avatarLabel = document.querySelector(".avatar-input__label");
  const avatarInput = document.querySelector(".avatar-input__input");
  const avatarImage = document.querySelector(".account-page__image img");

  if (avatarLabel) {
    avatarLabel.addEventListener("click", function () {
      avatarInput.addEventListener("change", function (event) {
        const file = event.target.files[0];
    
        if (file) {
          const reader = new FileReader();
          reader.onload = function (e) {
            avatarImage.src = e.target.result;
          };
          reader.readAsDataURL(file);
        } else {
          avatarImage.src = "";
        }
      });
    });
  }
}

export default AvatarInput;



